module.exports = __webpack_public_path__ + "static/media/ice-cream-1.ae4ce15c.png";